if (document.getElementById('page-recruit')) {
  // #page-topがあるページだけで実行
document.addEventListener('DOMContentLoaded', function () {
  const targets = document.querySelectorAll('.js-recruitReason')
  if (!targets.length) return

  const delay = 500 // ← 0.5秒ディレイ
  const timers = new Map() // 要素ごとのタイマー管理

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      const el = entry.target

      // 既存タイマーがあればクリア（出入りのブレ対策）
      if (timers.has(el)) {
        clearTimeout(timers.get(el))
        timers.delete(el)
      }

      if (entry.isIntersecting) {
        // 入ったとき → 0.5秒後にactive
        const timer = setTimeout(function () {
          el.classList.add('active')
          timers.delete(el)
        }, delay)

        timers.set(el, timer)

      } else if (entry.boundingClientRect.y > 0) {
        // 上に戻ったとき → 即解除（ここは遅らせない方が自然）
        el.classList.remove('active')
      }
    })
  }, {
    rootMargin: '-40% 0px -40% 0px',
    threshold: 0,
  })

  targets.forEach(function (el) {
    observer.observe(el)
  })
})


}

